import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import state from './state'
import getters from './getters'
import mutations from './mutations'

import modules from './modules'

Vue.use(Vuex)


export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	modules,
	strict: process.env.NODE_ENV !== 'production'
})


// WEBPACK FOOTER //
// ./src/store/index.js